import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Breadcum from "../layout/refactor/Breadcum/Breadcum";
import Common from "../based/Common";
import { useHistory } from "react-router-dom";
import TableFooter from "../based/content/TableFooter";
import PushingServices from "../based/services/PushingServices";
import { ConfirmDialog } from "../based/Dialog";

function PushingDesignManage(props) {
    const [paging, setPaging] = useState({ ...Common.Paging, orderBy: "id", orderDirection: "desc" });
    const history = useHistory();
    const [datas, setDatas] = useState([]);

    useEffect(() => {
        getDatas(paging);
    }, []);

    const getDatas = async (paging) => {
        const [err, data] = await PushingServices.GetPushingDesignLiteModels(paging);
        if (!err && data) {
            setDatas(data.listObjects);
            setPaging(data.paging);
        } else {
            setDatas([]);
            setPaging({ ...paging, totalItems: 0 });
        }
    };

    return (
        <>
            <Breadcum menu={["Trang chủ", "Quản lý đẩy thiết kế"]} title="Quản lý đẩy thiết kế" />
            <Wrapper>
                <div className="header-page">
                    {/* <div className="header-top">
                        <div className="box__header">
                            <div className={tabIndex === ARTWORK_STATUS.All ? "btn-tab active" : "btn-tab"} onClick={() => _handleChangeTab(ARTWORK_STATUS.All)}>
                                <span>Tất cả</span>
                            </div>
                            <div className={tabIndex === ARTWORK_STATUS.Initializing ? "btn-tab active" : "btn-tab"} onClick={() => _handleChangeTab(ARTWORK_STATUS.Initializing)}>
                                <span>Đang tạo</span>
                            </div>
                            <div className={tabIndex === ARTWORK_STATUS.Online ? "btn-tab active" : "btn-tab"} onClick={() => _handleChangeTab(ARTWORK_STATUS.Online)}>
                                <span>Đang hoạt động</span>
                            </div>
                            <div className={tabIndex === ARTWORK_STATUS.Offline ? "btn-tab active" : "btn-tab"} onClick={() => _handleChangeTab(ARTWORK_STATUS.Offline)}>
                                <span>Đang ẩn</span>
                            </div>
                        </div>
                    </div> */}
                    <div className="header-overview">
                        <div className="overview-left">
                            <button
                                className="btn btn-orange"
                                onClick={(e) => {
                                    e.preventDefault();
                                    // Handle the action for pushing multiple designs
                                    history.push("/pushing-multi-design-detail");
                                }}
                            >
                                <span>Đẩy sản phẩm nhiều thiết kế</span>
                            </button>
                        </div>
                        <div className="overview-right">
                            <div className="search-area">
                                <input
                                    type="text"
                                    value={paging.keyword}
                                    placeholder="Tìm kiếm thiết kế"
                                    onChange={(e) => {
                                        setPaging({ ...paging, keyword: e.target.value });
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                        }
                                    }}
                                />
                                <div className="icon-subfix">
                                    <div className="icon">
                                        <SearchIcon />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="table-artwork-header">
                        <div className="list-item">
                            <div
                                className="item"
                                style={{
                                    width: "10%",
                                }}
                            >
                                <input type="checkbox" />
                            </div>
                            <div
                                className="item"
                                style={{
                                    width: "calc(90% / 6)",
                                }}
                            >
                                <span>Sản phẩm</span>
                            </div>
                            <div
                                className="item"
                                style={{
                                    width: "calc(90% / 6)",
                                }}
                            >
                                <span>Thiết kế trong sản phẩm</span>
                            </div>
                            <div
                                className="item"
                                style={{
                                    width: "calc(90% / 6)",
                                }}
                            >
                                <span>Giá bán</span>
                            </div>
                            <div
                                className="item"
                                style={{
                                    width: "calc(90% / 6)",
                                }}
                            >
                                <span>Shop đã đẩy</span>
                            </div>
                            <div
                                className="item"
                                style={{
                                    width: "calc(90% / 6)",
                                }}
                            >
                                <span>Thời gian đẩy</span>
                            </div>
                            <div
                                className="item"
                                style={{
                                    width: "calc(90% / 6)",
                                }}
                            >
                                <span>Thao tác</span>
                            </div>
                        </div>
                    </div>

                    <div className="table-artwork-body">
                        {datas && datas.length > 0 ? (
                            datas.map((item, idx) => {
                                var lstDisplayName = [];
                                if (item.variantLiteModels && item.variantLiteModels.length > 0) {
                                    item.variantLiteModels.forEach((variant) => {
                                        if (!lstDisplayName.includes(variant.displayName) && lstDisplayName.length <= 5) lstDisplayName.push(variant.displayName);
                                    });
                                }
                                return (
                                    <div className="list-item" key={idx}>
                                        <div
                                            className="item"
                                            style={{
                                                width: "5%",
                                            }}
                                        >
                                            <input type="checkbox" />
                                        </div>
                                        <div
                                            className="item"
                                            style={{
                                                width: "calc(90% / 6 + 5%)",
                                                padding: "5px",
                                            }}
                                        >
                                            <div className="avatar-item">
                                                <img src={item.avatar} alt="" />
                                            </div>
                                            <span className="title-item">{item.name}</span>
                                        </div>
                                        <div
                                            className="item"
                                            style={{
                                                width: "calc(90% / 6)",
                                            }}
                                        >
                                            <div className="list-badge">
                                                {lstDisplayName &&
                                                    lstDisplayName.map((variant, i) => {
                                                        return <span className="badge">{variant}</span>;
                                                    })}
                                            </div>
                                        </div>
                                        <div
                                            className="item"
                                            style={{
                                                width: "calc(90% / 6)",
                                            }}
                                        >
                                            <span>
                                                {Common.formatCurrency(item.minPrice)} - {Common.formatCurrency(item.maxPrice)}
                                            </span>
                                        </div>
                                        <div
                                            className="item"
                                            style={{
                                                width: "calc(90% / 6)",
                                            }}
                                        >
                                            <div className="lst-shop">
                                                <span className="shop-item">
                                                    {item.shopName} ({item.platformName})
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="item"
                                            style={{
                                                width: "calc(90% / 6)",
                                            }}
                                        >
                                            <span className="status">{Common.formatDate(new Date(item.createdDate), "datetime")}</span>
                                        </div>
                                        <div
                                            className="item"
                                            style={{
                                                width: "calc(90% / 6)",
                                            }}
                                        >
                                            <div className="list-item-btn">
                                                <div className={`item-btn ${true ? "disable" : ""}`} onClick={() => {}}>
                                                    <div className="icon">
                                                        <EditIcon />
                                                    </div>
                                                    <span>Chỉnh sửa</span>
                                                </div>
                                                <div
                                                    className="item-btn"
                                                    onClick={(e) => {
                                                        ConfirmDialog("Xác nhận xóa?", "Bạn chắc chắn muốn xóa sản phẩm này?", () => {
                                                            return new Promise(async (resolve, reject) => {
                                                                const [err, data] = await PushingServices.DeletePushProduct(item.id);
                                                                if (!err && data) {
                                                                    getDatas(paging);
                                                                    resolve({ title: "Thành công", msg: "Xóa thành công." });
                                                                } else {
                                                                    reject({ title: "Lỗi", msg: "Xóa thất bại." });
                                                                }
                                                            });
                                                        });
                                                    }}
                                                >
                                                    <div className="icon">
                                                        <RemoveIcon />
                                                    </div>
                                                    <span>Xóa sản phẩm</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="text-center no-data">Không có dữ liệu</div>
                        )}
                        <TableFooter itemToDisplay={2} onFilter={(paging) => {}} paging={paging} />
                    </div>
                </div>
            </Wrapper>
        </>
    );
}

export default PushingDesignManage;

const Wrapper = styled.div`
    width: 90%;

    .list-item .item {
        padding: 5px;
    }

    .list-badge {
        width: 100%;
    }

    .list-badge .badge {
        overflow: hidden;
    }

    span.title-item {
        flex: 1;
    }

    .overview-right {
        width: 400px !important;
    }

    button.btn.btn-orange {
        border-radius: 8px;
        background: #ff9027;
        color: #fff;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        padding: 10px 16px;
    }

    .list-badge {
        display: flex;
        flex-wrap: wrap;
    }

    .list-badge .badge {
        border-radius: 30px;
        background: #fff5ec;
        color: #303030;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 5px;
        padding: 5px 10px;
    }

    .lst-shop {
        display: flex;
        flex-direction: column;
    }

    .lst-shop .shop-item {
        margin: 5px;
    }

    .avatar-item {
        width: 100px;
        height: 100px;
        flex-shrink: 0;
    }

    .title-item {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .avatar-item img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .list-item-btn {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .main_instruction {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff5ec;
        padding: 16px;
        margin: 12px 0;
    }

    .title p {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-bottom: 6px;
    }

    .title ul {
        padding-left: 22px;
        margin-bottom: 0;
    }

    .title ul li {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .title ul li span.high-light {
        color: #ff9027;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .list-thumbnail {
        height: 100%;
        width: 100%;
        padding: 10px;
    }

    .no-data {
        background: white;
        margin: 12px 0;
        padding: 12px 24px;
        border-radius: 12px;
        font-weight: 500;
        font-family: Lexend;
    }

    .list-item-btn {
        width: 100%;
        height: 100%;
    }

    .item-btn {
        display: flex;
        align-items: center;
        margin: 6px 0;
        cursor: pointer;
    }

    .item-btn span {
        width: 100%;
        display: flex;
        align-items: center;
        margin: 6px 0;
        color: #13aaff;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

        margin-left: 4px;

        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .item-btn span .icon {
        margin: 0 12px;
    }

    span.status {
        color: #28b259;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        border-radius: 20px;
        background: #ecf8f0;
        padding: 10px 12px;
    }

    .list-thumbnail {
        display: flex;
    }

    .thumbnail {
        width: 50%;
        height: 100%;
        display: flex;
    }

    .thumbnail img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .table-artwork-body .list-item .item {
        height: 100%;
        border-right: 1px solid #f1f1f1;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .table-artwork-body .list-item .item:last-child {
        border: none;
    }
    .table-artwork-body .list-item {
        padding: 0px 16px;
        background: white;
        margin: 12px 0;
        border-radius: 12px;
        height: 170px;
    }
    .list-item {
        display: flex;
        align-items: center;
    }

    .item {
        text-align: center;
        color: #303030;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .header-overview {
        display: flex;
        align-items: center;
    }

    .overview-right {
        margin-left: auto;
        display: flex;
    }

    .search-area {
        display: flex;
        align-items: center;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 12px 16px 12px 20px;
        margin-right: 12px;
    }

    .search-area input[type="text"] {
        border: none;
        width: 100%;
    }

    .overview-right {
        width: 400px;
    }

    .search-area {
        width: 100%;
    }

    .status-options {
        width: 200px;
        display: flex;
        align-items: center;
    }

    .status-options > div {
        width: 100%;
    }

    .react-select__control {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
        padding: 11px 13px;
    }

    hr {
        border: 1px solid #f3f3f3 !important;
        width: 100%;
    }

    .overview-left {
        display: flex;
        flex-wrap: wrap;
    }

    .overview-area {
        border-radius: 10px;
        background: #f8f8f8;
        padding: 6px 16px;
        margin: 6px;
    }

    .overview-area label {
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .overview-value {
        color: #303030;
        font-family: Lexend;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .header-top {
        display: flex;
        flex: 1;
    }

    .btn-add-new {
        border-radius: 40px;
        background: #ff9027;
        display: flex;
        align-items: center;
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 13px 18px;
        align-items: center;
        cursor: pointer;
    }

    .icon {
        display: flex;
        margin-left: 14px;
    }

    .add-new {
        margin-left: auto;
    }

    .header-page {
        display: flex;
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 10px 16px;
        flex-direction: column;
    }

    .box__header {
        display: flex;
        align-items: center;
    }

    .btn-tab {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 0 6px;
        cursor: pointer;
        padding: 12px 18px;
    }

    .btn-tab.active {
        border-radius: 8px;
        background: #fff5ec;
        color: #ff9027;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
`;

const SearchIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
            <path
                d="M8.67414 16.1886C12.9125 16.1886 16.3483 12.7885 16.3483 8.5943C16.3483 4.40008 12.9125 1 8.67414 1C4.43583 1 1 4.40008 1 8.5943C1 12.7885 4.43583 16.1886 8.67414 16.1886Z"
                stroke="#303030"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path d="M14.312 14.1736L18.0861 17.9084" stroke="#303030" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

const RemoveIcon = () => {
    return (
        <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.2209 20H5.69325C4.4908 20 3.54601 19.1515 3.37423 17.9636L2 6H16L14.5399 17.9636C14.3681 19.1515 13.4233 20 12.2209 20Z"
                stroke="#13AAFF"
                stroke-width="1.8"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path d="M1 3.5H17" stroke="#13AAFF" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round" />
            <path d="M6.41699 1H11.7504" stroke="#13AAFF" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round" />
            <path d="M7 9.6665L7.36356 15.3333" stroke="#13AAFF" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10.9997 9.6665L10.5635 15.3333" stroke="#13AAFF" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

const EditIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 19H19" stroke="#13AAFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M14.5 2.49998C14.8978 2.10216 15.4374 1.87866 16 1.87866C16.2786 1.87866 16.5544 1.93353 16.8118 2.04014C17.0692 2.14674 17.303 2.303 17.5 2.49998C17.697 2.69697 17.8532 2.93082 17.9598 3.18819C18.0665 3.44556 18.1213 3.72141 18.1213 3.99998C18.1213 4.27856 18.0665 4.55441 17.9598 4.81178C17.8532 5.06915 17.697 5.303 17.5 5.49998L5 18L1 19L2 15L14.5 2.49998Z"
                stroke="#13AAFF"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
